// extracted by mini-css-extract-plugin
module.exports = {"i1dz9q5z":"i1dz9q5z"};